(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gingerpurr-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gingerpurr-colors')) {
  customElements.define('gingerpurr-colors', class extends HTMLElement {
    connectedCallback() {
      this.onChange = (event) => {
        const picker = event.target.closest('variant-picker');
        if (!picker || picker.dataset.productId !== this.dataset.productId) return;
        const options = picker.getAllSelectedOptions();
        this.querySelectorAll('figure').forEach((figure) => {
          const color = options[Number(figure.dataset.position)]?.value;
          const source = figure.dataset[color?.toLowerCase()];
          if (!source) return;
          const img = figure.querySelector('img');
          img.removeAttribute('srcset');
          img.src = source;
          img.alt = figure.dataset.label + ' · ' + color;
          figure.querySelector('span').textContent = color;
        });
      };
      document.addEventListener('change', this.onChange);
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
